import {ReactNode} from 'react';

export const TableSidebarFooter = ({children}: {children?: ReactNode}) => {
  return (
    <div className="sticky bottom-0 flex items-center justify-between border-t border-sw-border bg-sw-background">
      {children}
    </div>
  );
};
